import { InstructionsKey } from '../../models/question';
import { InstructionComponent } from '../../models/instructions';
import React from 'react';
import LinkButton from '../../components/shared/LinkButton';

export class H implements InstructionComponent {
  getInstructionKey = () => InstructionsKey.H;
  isEnable = () => true;
  getIconSrc = () => '/rpo/svg/hejtstop.svg';
  getTitle = () => 'Zgłoś do HejtStop.pl';
  getContent = () => (
    <>
      <p>
        <LinkButton link='http://hejtstop.pl/'>HejtStop.pl</LinkButton>
      </p>
      <p>
        Celem akcji HejtStop jest walka z rasizmem, antysemityzmem, homofobią oraz każdą formą nienawiści pojawiającą
        się w przestrzeni publicznej. HejtStop przekazuje zgłoszony do nich przez internautów hejt do odpowiednich
        służb.
      </p>
    </>
  );
}
